import React from "react";
import CaseListPage from "./CaseListPage";
import { onHoldCasesConfig } from "./caseListConfig";
import UpdateCase from "@mods/caseManagement/cases/components/UpdateCase";

/**
 * Held cases are editable straight from the list: saving an edit is what
 * takes a case off hold, so making the doctor open the case first would
 * add a step to the one thing this page exists for.
 */
const config = {
  ...onHoldCasesConfig,
  onEditComponent: ({ data, onUpdated, onClosed }) => (
    <UpdateCase data={ data } onUpdated={ onUpdated } onClosed={ onClosed } />
  ),
};

const IndexUserOnHoldCases = () => <CaseListPage config={ config } />;

export default IndexUserOnHoldCases;
